// Easter eggs

const $body = $('body');

$('#ee_comic').click( function(e) {
    e.preventDefault();
    $body.css('font-family','Comic Sans MS');
});

let dbk_input = '';

$body.on('keypress', function(e) {
    if ($(e.target).is('input') || $(e.target).is('textarea')) {
        return;
    }

    dbk_input += String.fromCharCode(e.keyCode);

    if (dbk_input.match(/dbk/gi)) {
        if ($body.hasClass('flipped')) {
            if ($body.hasClass('rotated')) {
                $body.removeClass('rotated').removeClass('flipped');
            } else {
                $body.addClass('rotated');
            }
        } else {
            $body.addClass('flipped');
        }

        dbk_input = '';
    }
});
